export const BACKGROUND_TYPE_NAME = {
  THEME: 'THEME',
  CATEGORY: 'CATEGORY',
  CUSTOM: 'CUSTOM',
  FAVORITE: 'FAVORITE'
};

export const BACKGROUND_TYPE = {
  [BACKGROUND_TYPE_NAME.THEME]: {
    id: 0,
    name: 'Theme'
  },
  [BACKGROUND_TYPE_NAME.CATEGORY]: {
    id: 1,
    name: 'Category'
  },
  [BACKGROUND_TYPE_NAME.CUSTOM]: {
    id: 2,
    name: 'Custom Backgrounds'
  },
  [BACKGROUND_TYPE_NAME.FAVORITE]: {
    id: 3,
    name: 'Saved Favorites'
  }
};

export const BACKGROUND_PAGE_TYPE = {
  GENERAL: {
    id: 0,
    name: 'General',
    type: 'GENERAL'
  },
  SINGLE_PAGE: {
    id: 1,
    name: 'Single Page',
    type: 'SINGLE_PAGE'
  },
  DOUBLE_PAGE: {
    id: 2,
    name: 'Spread',
    type: 'DOUBLE_PAGE'
  },
  DIGITAL: {
    id: 2,
    name: 'Digital',
    type: 'DIGITAL'
  }
};
export const CUSTOM_BACKGROUND_TYPE = -999;

export const SAVED_BACKGROUND_TYPE = {
  name: 'Saved Backgrounds',
  id: CUSTOM_BACKGROUND_TYPE,
  value: CUSTOM_BACKGROUND_TYPE
};
